<template>
  <div>
    <!-- 历史标签  -->
    <el-dialog :title="$t('message.historyTag')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="1080px" center>
      <div class="content">
        <div class="tabs">
          <el-tabs v-model="datas.type" type="card" @tab-click="handleClick">
            <el-tab-pane label="亚马逊FBA" name="FBA"></el-tab-pane>
            <el-tab-pane label="乐天" name="LETIAN"></el-tab-pane>
            <el-tab-pane label="雅虎" name="YAHU"></el-tab-pane>
            <el-tab-pane label="ZOZO" name="ZOZO"></el-tab-pane>
          </el-tabs>
        </div>
        <div class="table">
          <ol>
            <!-- 商品管理编码 -->
            <li>
              {{ $t("message.commodityManagementCode") }}
            </li>
            <!-- 标签编码 -->
            <li class="flex15">
              {{ $t("message.tagCoding") }}
            </li>
            <li>文本信息</li>
            <li>文本信息2</li>
            <li>文本信息3</li>
            <li>文本信息4</li>
            <!-- 操作 -->
            <li>
              {{ $t("message.operation") }}
            </li>
          </ol>
          <!-- 第一行 -->
          <ul v-for="(item, index) in list" :key="index">
            <!-- 商品管理编码 -->
            <li>
              {{ item.goods_no }}
            </li>
            <!-- 标签编码 -->
            <li class="flex15">
              {{ item.no }}
            </li>
            <li>{{ item.text_line_one }}</li>
            <li>{{ item.text_line_two }}</li>
            <li>{{ item.text_line_three }}</li>
            <li>{{ item.text_line_four }}</li>
            <!-- 操作 -->
            <li>
              <el-button type="primary" class="primary" size="small" @click="choose(item)" v-if="status == 20">
                {{ $t("message.choose") }}</el-button>
              <!-- <el-button type="danger"  size="small" @click="choose(item)" v-if="status == 20">
                  {{ $t("message.delete") }}</el-button> -->
            </li>
          </ul>
          <div class="noDada" v-if="list == false">
            暂无历史标签
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  props: {
    itemData: { type: Object },
  },
  computed: {
    ...mapState(
      { status: (state) => state.porderDetail.status, }
    )

  },
  data() {
    return {
      porder_sn: this.$route.query.porder_sn,
      datas: {
        type: 'FBA'
      },
      tagList: [],
      list: [],
      dialogVisible: false,
    };
  },
  methods: {
    //切换type
    handleClick() {
      this.list = this.tagList.filter(item => item.type == this.datas.type)
    },
    // 历史标签
    goodsTagLog() {
      let datas = {
        order_detail_id: this.itemData.order_detail_id,
        order_sn: this.itemData.order_sn,
      }
      this.$api.porderApi.goodsTagLog(datas).then((res) => {
        this.tagList = res.data
        this.handleClick()

      })
    },

    // 选择
    choose(item) {

      let optionData = this.itemData.option.find(item => item.name == 'FBA贴标')
      if (optionData == undefined) return this.$message.error('商品没有FBA贴标服务，无法自动生成标签')
      let datas = {
        porder_detail_id: this.itemData.id,
        type: item.type,
        no: item.no,
        goods_no: item.goods_no,
        num: optionData.num,
        code_type: 'CODE128',
        text_line_one: item.text_line_one,
        text_line_two: item.text_line_two,
        text_line_three: item.text_line_three,
        text_line_four: item.text_line_four,

      }
      this.$api.porderApi.updateTag(datas).then((res) => {
        this.$message.success(res.msg);
        this.dialogVisible = false;
        this.$store.dispatch("porderDetail", { porder_sn: this.porder_sn });
      });
    },

  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        this.goodsTagLog()
      }
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-radio__input {
  transform: scale(1.5);
}

.content {
  margin: 0px 15px;

  .table {
    border: 1px solid #edeff4;
    max-height: 600px;
    overflow-y: auto;
    position: relative;

    ol {
      display: flex;
      position: sticky;
      top: 0;
      left: 0;
    }

    ul {
      display: flex;
      padding: 0;

      &:nth-last-child(1) {
        border: 0;
      }

      li {
        padding: 5px 0;
      }
    }

    li {
      border-right: 1px solid #edeff4;

      &:nth-last-child(1) {
        border: 0;
      }
    }

    .flex15 {
      flex: 1.5;
    }
  }

  .noDada {
    text-align: center;
    margin: 20px 0;
  }
}
</style>